import React from "react";
import i18n from "../../i18n";
import { Tooltip } from "antd";
import { OButton } from "./OButton";
import { ExcelIcon } from "../../theme/Icons";

export default ({loading, onClick, text, disabled = false})=>{
	const button = (
		<OButton disabled={disabled} icon="file-excel" onClick={onClick} loading={loading}>
			{text || i18n.t("export_excel")}
		</OButton>
	);
	if(disabled){
		return (
			<Tooltip placement="left" title={i18n.t("export_filter_require")}>
				{button}
			</Tooltip>
		);
	}
	return button;
};


// WEBPACK FOOTER //
// ./src/components/button/ExportButton.js